import { useEffect, useRef, useState } from 'react'
import { FiSearch } from 'react-icons/fi'

import { t } from 'i18next'
import { debounce } from 'lodash'

import Input from '~/components/Form/Input'
import { history, isPublisher } from '~/helpers'
import useQueryParams from '~/hooks/useQuery'

import FilterAdtype from '../../Filters/FilterAdTypes'
import FilterCampaignStatus from '../../Filters/FilterCampaignStatus'
import FilterPublisherTag from '../../Filters/FilterPublisherTag'
import FilterTargetingType from '../../Filters/FilterTargetingType'

const CampaignListFilters = () => {
  const [innerLoading, setInnerLoading] = useState(false)

  const searchParams = useQueryParams()

  const campaign_name = searchParams.get('campaign_name')
  const seller_id = searchParams.get('seller_id')

  const [data, setData] = useState({
    campaign_name,
    seller_id
  })

  useEffect(() => {
    setData({
      campaign_name: campaign_name || '',
      seller_id: seller_id || ''
    })
  }, [campaign_name, seller_id])

  const executeDebounceFunc = (func: () => void) => func()

  const handleDebounce = useRef(debounce(executeDebounceFunc, 1000)).current

  const handleFilter = (data: OnChangeInputData) => {
    const { name, value } = data

    if (!value) {
      const newParams = new URLSearchParams(searchParams.toString())
      newParams.delete(name)
      history.push({ search: newParams.toString() })
      setInnerLoading(false)

      return
    }

    searchParams.set(name, String(value))
    searchParams.set('page', '1')
    history.push({ search: searchParams.toString() })

    setInnerLoading(false)
  }

  const handleChange = (data: OnChangeInputData) => {
    setInnerLoading(true)

    setData(prevState => ({ ...prevState, [data.name]: data.value }))

    handleDebounce(() => handleFilter(data))
  }

  return (
    <form className="d-flex gap-2 mb-2">
      <Input
        name="campaign_name"
        onChange={handleChange}
        value={data.campaign_name}
        icon={FiSearch}
        placeholder={t('rm:filterByCampaignName')}
        type="search"
        loading={innerLoading}
      />

      <FilterCampaignStatus />

      <FilterAdtype />

      <FilterTargetingType />

      {isPublisher() && <FilterPublisherTag />}
    </form>
  )
}

export default CampaignListFilters
